import CustomButton from "../../../../../components/custom/button";
import AddressListSkeleton from "../../../profilePage/skelitons/ManageAddressListSkeleton";
import { useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { getAddressListAsync } from "../../../../../../app/slices/addressSlice/ProfileSlice";
import CustomDialog from "../../../../../components/custom/dialog";
import { AddOrEditAddress } from "../../../profilePage/components/address/AddOrEditAddress";
import { DeleteAddress } from "../../../profilePage/components/address/DeleteAddress";
import useFetchCurrentLocation from "./FetchCurrentLocationAndPlace";
import { EmptyAddressList } from "../../../profilePage/components/emptyStates/EmptyStatesProfile";
import {
  setInfoButtonDisabled,
  setStepperActiveMenu,
  selectedAddressId,
  getAddressChangeAsync,
} from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import {
  setAddressType,
  setCheckoutAddressId,
} from "../../../../../../app/slices/common/locationSlice/locationSlice";
import { LocationConfirmationPrompt } from "../../../../public/locationSearchbar/LocationConfirmationPromt";

export const DeliverAddress = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const dispatch = useAppDispatch();
  const { addressList }: any = useAppSelector((state) => state?.AddressState);
  const { isValidUser }: any = useAppSelector((state) => state.ProfileState);
  const location = useAppSelector((state) => state.locationState);

  const [modalType, setModalType] = useState("");
  const [addressId, setAddressId] = useState("");
  const [selectedAddressType, setSelectedAddressType] = useState("");

  const [selectedAddress, setSelectedAddress] = useState("home");
  const [lat, setLat] = useState<any>(null);
  const [lng, setLng] = useState<any>(null);
  const [selectedCheckoutAddress, setSelectedCheckoutAddress] = useState("");

  const { place } = useFetchCurrentLocation();
  // const isInputFilled = selectedAddress.trim() !== "";
  const isInputFilled =
    addressId !== "" && addressId !== undefined && addressId !== null;
  const checkoutAddressId = useAppSelector(
    (state) => state.locationState.setCheckoutAddressId
  );

  useEffect(() => {
    if (checkoutAddressId) {
      setAddressId(checkoutAddressId);
      dispatch(selectedAddressId(checkoutAddressId));
    } else {
      setAddressId(location?.locationGot?.address_id);
      dispatch(selectedAddressId(location?.locationGot?.address_id));
    }
  }, [dispatch, location?.locationGot?.address_id, checkoutAddressId]);

  // useEffect(() => {
  //   setAddressId(location?.locationGot?.address_id);
  //   dispatch(selectedAddressId(location?.locationGot?.address_id));
  // }, [dispatch, location?.locationGot?.address_id]);

  useEffect(() => {
    dispatch(setInfoButtonDisabled(!isInputFilled && isValidUser));
  }, [isInputFilled, dispatch]);
  useEffect(() => {
    dispatch(getAddressListAsync());
  }, []);
  const onModalSelection = (type: string, item?: any) => {
    if (type !== "add") {
      setAddressId(item?.id);
    }
    setSelectedAddressType(item?.address_type);

    setModalType(type);
  };
  const modalClose = () => {
    setModalType("");
    setAddressId("");
  };
  const promptClose = () => {
    setModalType("");
  };
  const onModalCloseCallback = (event: any) => {};
  const onNextClick = (active: any) => {
    // const payload: any = {
    //   address_id: Number(addressId),
    // };
    // dispatch(getAddressChangeAsync(payload)).then((response: any) => {
    //   if (response?.payload?.data?.proceed) {
    dispatch(setStepperActiveMenu(active));
    //   } else {
    //     onModalSelection("locationConfirmation");
    //   }
    // });
  };
  const handleRadioChange = (event: any, value: any) => {
    setSelectedCheckoutAddress(value);
    const payload: any = {
      address_id: Number(value.id),
    };
    dispatch(getAddressChangeAsync(payload)).then((response: any) => {
      if (response?.payload?.data?.proceed) {
        setSelectedAddress(value?.address_type); // Update the selected address
        setLat(Number(value.latitude));
        setLng(Number(value.longitude));
        dispatch(setAddressType(value?.address_type));
        setAddressId(value?.id);
        dispatch(selectedAddressId(value?.id));
        // dispatch(setCheckoutAddressId(""));
        // onCloseModal();
      } else {
        onModalSelection("locationConfirmation");
      }
    });
  };

  return (
    <div>
      <div className="row mt-3">
        <div className="col-md-12 px-0">
          <h2>Select a delivery address</h2>
          <div className="card mb-3 card-navya">
            <div className="card-body">
              <div className="row justify-content-between align-items-start">
                <div className="pe-3 col-auto">
                  <HomeOutlinedIcon color="secondary" fontSize="large" />
                </div>
                <div
                  style={{
                    fontFamily: "Albert Sans, sans-serif",
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: "400",
                  }}
                  className="col"
                >
                  <p>
                    <b>Add New Address</b>
                  </p>
                  <p className="mb-2">You seem to be in a new Address</p>
                  <p className="text-semi">{place && place}</p>
                  <div className="tf-btn radius-3 justify-content-center">
                    <CustomButton
                      size="large"
                      endIcon={<AddIcon />}
                      fullWidth
                      name="Add New Address"
                      onClick={() => onModalSelection("add")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-account-content account-order">
        <div className="row mb-2"></div>
        {addressList?.loader ? (
          <AddressListSkeleton />
        ) : (
          <>
            <div className="row padd-adj">
              {addressList?.data?.length > 0 ? (
                addressList?.data?.map((item: any, index: any) => {
                  return (
                    <div className="col-md-6 ps-0 " key={index}>
                      <div
                        onClick={(e: any) => handleRadioChange(e, item)}
                        className="card mb-3 card-navya"
                        style={{
                          border:
                            addressId === item.id
                              ? "1px solid rgb(252, 87, 50)"
                              : "",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="card-body"
                          style={{
                            fontFamily: "Albert Sans, sans-serif",
                            fontSize: "14px",
                            lineHeight: "22px",
                            fontWeight: "400",
                          }}
                        >
                          <div className="row">
                            <div className="col-md-2">
                              <div className="">
                                <div className="pe-3">
                                  <div>
                                    <p>
                                      {item?.address_type === "work" && (
                                        <WorkOutlineOutlinedIcon
                                          color="secondary"
                                          fontSize="small"
                                        />
                                      )}
                                      {item?.address_type === "other" && (
                                        <WorkOutlineOutlinedIcon
                                          color="secondary"
                                          fontSize="small"
                                        />
                                      )}
                                      {item?.address_type === "home" && (
                                        <HomeOutlinedIcon
                                          color="secondary"
                                          fontSize="small"
                                        />
                                      )}
                                      {/* &nbsp; &nbsp; */}
                                      {/* <b>{item?.address_type?.toUpperCase()}</b> */}
                                    </p>
                                    {/* <p className="m-2 ">
                                      {`${item?.flat_no}, ${item?.landmark}`}
                                    </p> */}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-10">
                              <div>
                                <p>
                                  <b>{item?.address_type?.toUpperCase()}</b>
                                </p>
                                <p className="mb-2">
                                  {`${item?.flat_no}, ${item?.landmark}`}
                                </p>
                              </div>
                              <div className="row">
                                <div className="col-6">
                                  <CustomButton
                                    name="Edit"
                                    fullWidth
                                    onClick={() =>
                                      onModalSelection("edit", item)
                                    }
                                  />
                                </div>{" "}
                                <div className="col-6">
                                  <CustomButton
                                    className="ml-2"
                                    fullWidth
                                    color="secondary"
                                    name="Delete"
                                    onClick={() =>
                                      onModalSelection("delete", item)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <EmptyAddressList />
              )}
            </div>{" "}
            <CustomButton
              endIcon={<ArrowForwardIcon />}
              className="ml-2"
              name="Continue"
              onClick={() => onNextClick("deliveryInfo")}
              disabled={!isInputFilled}
            />
          </>
        )}
      </div>
      <CustomDialog
        component={
          <AddOrEditAddress
            addressId={addressId}
            modalClose={modalClose}
            modalType={modalType}
          />
        }
        title="Edit"
        openDialog={modalType === "edit"}
        handleCloseDialog={modalClose}
        modalPlace="right"
      />
      <CustomDialog
        component={
          <AddOrEditAddress modalType={modalType} modalClose={modalClose} />
        }
        title="Add New Address"
        openDialog={modalType === "add"}
        handleCloseDialog={modalClose}
        modalPlace="right"
      />
      <CustomDialog
        component={
          <DeleteAddress
            type={selectedAddressType}
            modalClose={modalClose}
            addressId={addressId}
          />
        }
        title="Delete"
        openDialog={modalType === "delete"}
        handleCloseDialog={modalClose}
      />
      <CustomDialog
        component={
          <LocationConfirmationPrompt
            address={selectedCheckoutAddress}
            onClose={promptClose}
            onModalCloseCallback={onModalCloseCallback}
            isFromCheckout={true}
          />
        }
        title=""
        openDialog={modalType === "locationConfirmation"}
        handleCloseDialog={promptClose}
        modalPlace="center"
      />
    </div>
  );
};
